import React from 'react'
import { Card, CardBody, CardHeader, Modal, Stack, Typography } from '@prometheus/components'
import { truncateCash } from '@prometheus/utils'
import { useSelector } from '../../../../hooks/useSelector'
import { BossAttackForm } from './BossAttackForm'
import { BossSprite } from './BossSprites'
import './BossPanel.scss'

/** The board-click answer: tap the boss's marked planet, get the attack form. */
export const BossAttackModal = ({ onClose }: { onClose: () => void }) => {
  const boss = useSelector(s => s.game.metadata?.boss)

  if (!boss?.alive) {
    return null
  }

  return (
    <Modal onClose={onClose}>
      <Card className="pg-boss-panel" style={{ '--boss-color': boss.color } as React.CSSProperties}>
        <CardHeader>
          <div className="pg-boss-panel__head">
            <BossSprite color={boss.color} width={36} className="pg-boss-panel__sprite" />
            <Typography variant="h4" retro className="pg-boss-panel__race">Attack the {boss.race}</Typography>
          </div>
        </CardHeader>
        <CardBody>
          <Stack space="sm">
            <Typography variant="body2">
              Their mothership over {boss.anchor_planet} holds{' '}
              {truncateCash(boss.health, { raw: true })} / {truncateCash(boss.max_health, { raw: true })} hull.
            </Typography>
            <BossAttackForm onDone={onClose} />
          </Stack>
        </CardBody>
      </Card>
    </Modal>
  )
}
